import { forwardRef } from 'react';
import { DisplayMode } from '../views-components/DisplayMode';
import TextInput from '../views-components/TextInput';
import { useInputProps } from './useInputProps';
import { useSignupData } from './useSignupData';
import SignupFormControl from '../views-components/FormControl';
import { jsx as _jsx } from "react/jsx-runtime";
export const SignupDataInput = /*#__PURE__*/forwardRef(({
  dataKey,
  disabled = false,
  displayMode = DisplayMode.Placeholder,
  customValidationError,
  renderExtraIcons,
  type,
  inputMode,
  autoFocus = true,
  help,
  shouldShowPlaceholder = false,
  onFocus,
  onBlur,
  shouldTrimData = false,
  labelOverride,
  formControlMaxInlineSize,
  updateInputStyle = false
}, ref) => {
  const {
    data,
    setData
  } = useSignupData(dataKey, shouldTrimData);
  const inputProps = useInputProps(dataKey);
  const placeholder = shouldShowPlaceholder ? inputProps.placeholder : '';
  const renderInput = () => {
    return /*#__PURE__*/_jsx(TextInput, Object.assign({
      autoFocus: autoFocus,
      "data-test-id": dataKey,
      disabled: disabled,
      displayMode: displayMode,
      inputMode: inputMode,
      ref: ref,
      renderExtraIcons: renderExtraIcons,
      type: type,
      value: disabled ? '' : data,
      onBlur: onBlur,
      onChange: setData,
      onFocus: onFocus
    }, inputProps, {
      placeholder: placeholder,
      updateInputStyle: updateInputStyle
    }));
  };
  const maybeWrapTextInput = () => {
    return /*#__PURE__*/_jsx(SignupFormControl, {
      customValidationError: customValidationError,
      dataKey: dataKey,
      help: help,
      labelOverride: labelOverride,
      maxInlineSize: formControlMaxInlineSize,
      updateInputStyle: updateInputStyle,
      children: renderInput()
    });
  };
  return maybeWrapTextInput();
});